import { TestTube, ExternalLink } from "lucide-react";
import { TestDto } from "@shared/types/WorkOrderDto";
import { formatDate, getTestStateConfig } from "./utils";

export function TestCard({ test }: { test: TestDto }) {
  const stateConfig = getTestStateConfig(test.state);
  const StateIcon = stateConfig.icon;

  return (
    <a
      href={test.link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-start gap-3 p-3 rounded-lg border border-border/50 hover:bg-card/50 hover:border-primary/30 transition-all"
    >
      <div className="w-8 h-8 rounded-lg bg-cyan-500/10 flex items-center justify-center shrink-0">
        <TestTube className="h-4 w-4 text-cyan-500" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-sm font-medium truncate">{test.testName}</p>
          <StateIcon className={`h-4 w-4 shrink-0 ${stateConfig.className}`} />
        </div>
        <p className="text-xs text-muted-foreground truncate mt-0.5">
          {test.testDescription}
        </p>
        <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
          <span>{test.repo}</span>
          <span>•</span>
          <span>{formatDate(test.createdAt)}</span>
        </div>
      </div>
      <ExternalLink className="h-4 w-4 text-muted-foreground shrink-0" />
    </a>
  );
}
